import './OraclePrices.css'
import { FC, useEffect, useMemo, useRef } from 'react'
import { Grid, Typography } from '@mui/material'
import {
  AccountType,
  getPythProgramKeyForCluster,
  parseBaseData,
  parsePriceData,
  parseProductData,
  PriceData,
  Product,
} from '@pythnetwork/client'
import { PYTH_SOLANA_CLUSTER_NAME } from '../../utils/constants'
import {
  AccountInfo,
  clusterApiUrl,
  Connection,
  PublicKey,
} from '@solana/web3.js'
import { useDispatch, useSelector } from 'react-redux'
import {
  getOraclePrices,
  setOraclePrices,
  setOracleTimer,
} from '../../redux/modules/app'

export const OraclePrices: FC = () => {
  const oraclePrices = useSelector(getOraclePrices)
  const dispatch = useDispatch()
  const componentIsMounted = useRef(true)

  const connection = useMemo(
    () => new Connection(clusterApiUrl(PYTH_SOLANA_CLUSTER_NAME)),
    []
  )

  const pythPublicKey = getPythProgramKeyForCluster(PYTH_SOLANA_CLUSTER_NAME)

  useEffect(() => {
    return () => {
      componentIsMounted.current = false
      dispatch(setOracleTimer(null))
    }
  }, [dispatch])

  useEffect(() => {
    async function getPrices() {
      const accounts = await connection.getProgramAccounts(
        pythPublicKey,
        'finalized'
      )
      let productAccountKeyToProduct: Record<string, Product> = {}
      let priceAccountKeyToProductAccountKey: Record<string, string> = {}
      let marketToPriceData: Record<string, PriceData> = {}

      function handleAccounts(
        accounts: {
          pubkey: PublicKey
          account: AccountInfo<Buffer>
        }[],
        productOnly: boolean
      ) {
        for (const account of accounts) {
          const base = parseBaseData(account.account.data)
          if (base) {
            switch (AccountType[base.type]) {
              case 'Mapping':
                break
              case 'Product':
                if (productOnly) {
                  const { priceAccountKey, product } = parseProductData(
                    account.account.data
                  )
                  productAccountKeyToProduct[account.pubkey.toString()] =
                    product
                  if (
                    priceAccountKey.toString() !==
                    '11111111111111111111111111111111'
                  ) {
                    priceAccountKeyToProductAccountKey[
                      priceAccountKey.toString()
                    ] = account.pubkey.toString()
                  }
                }
                break
              case 'Price':
                if (!productOnly) {
                  const productLookup =
                    productAccountKeyToProduct[
                      priceAccountKeyToProductAccountKey[
                        account.pubkey.toString()
                      ]
                    ]
                  if (productLookup) {
                    const priceData = parsePriceData(account.account.data)
                    marketToPriceData[productLookup.symbol] = priceData
                  }
                }
                break
              case 'Test':
                break
              default:
                throw new Error(
                  `Unknown account type: ${base.type}. Try upgrading pyth-client.`
                )
            }
          }
        }
      }

      marketToPriceData = {}
      handleAccounts(accounts, true)
      handleAccounts(accounts, false)

      if (marketToPriceData) {
        dispatch(
          setOraclePrices({
            SOL_USD: marketToPriceData['SOL/USD'],
            BANANA_USD: marketToPriceData['USDC/USD'],
            KONG_USD: marketToPriceData['ETH/USD'],
          })
        )
      }
    }

    if (!oraclePrices.timer) {
      if (!oraclePrices.SOL_USD) {
        getPrices()
      }
      dispatch(setOracleTimer(setInterval(() => getPrices(), 5000)))
    }
  })

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Typography component="div" className="Oracle-price-text">
          BANANA/USD
          <br />
          {oraclePrices.BANANA_USD
            ? '$' + oraclePrices.BANANA_USD?.price.toFixed(2)
            : ''}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography component="div" className="Oracle-price-text">
          SOL/USD
          <br />
          {oraclePrices.SOL_USD
            ? '$' + oraclePrices.SOL_USD?.price.toFixed(2)
            : 'Loading ...'}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography component="div" className="Oracle-price-text">
          KONG/USD
          <br />
          {oraclePrices.KONG_USD
            ? '$' + oraclePrices.KONG_USD?.price.toFixed(2)
            : ''}
        </Typography>
      </Grid>
    </Grid>
  )
}
